// extracted by mini-css-extract-plugin
export default {"scroll-container":"styles_scroll-container__IJzAL"};